import { StackView, Spinner } from '@planningcenter/tapestry-react';
import React from 'react';
import { Subheading } from '../ui/subheading.js';

const Section = ({ children, loading, title }) => {
    return (React.createElement(StackView, { spacing: 1 },
        React.createElement(StackView, { spacing: 1, alignment: "center", axis: "horizontal" },
            React.createElement(Subheading, null, title),
            loading && React.createElement(Spinner, { size: "sm" })),
        React.createElement(React.Fragment, null, children)));
};

export { Section };
//# sourceMappingURL=section.js.map
